// extracted by mini-css-extract-plugin
export default {"rating":"EK-z","numberOfStars":"FK-z","count":"GK-z","barGraphSpacing":"HK-z","barGraph":"IK-z"};